import React from 'react';
import { Box } from '@mui/material';
import { Link, Typography } from '@tkww/the-bash-frontend';

import { SectionContainer } from 'components/grid';
import BookingBenefitCard from 'views/GuaranteePage/BookingBenefitCard';
import background from 'public/images-next/plannerValueProposition/background.svg';

const BOOKING_BENEFIT_ITEMS = [
  {
    title: 'Booking Protection',
    description:
      "All reviews are sourced from verified bookings on The Bash. Also, in the unlikely event of a vendor cancellation, we'll help you find a replacement, and refund payments made on The Bash.",
    icon: '/images-next/guarantee-page/booking-protection-icon.svg',
    iconBackgroundColor: '#FFE2A9',
  },
  {
    title: 'Money-Back Promise',
    description: (
      <>
        You&apos;ll never lose a deposit or balance payment made through The Bash with our{' '}
        <Link path="/event-protection">100% money-back guarantee</Link>. Online payments are secure
        through Stripe and are U.S. only.{' '}
      </>
    ),
    icon: '/images-next/guarantee-page/money-back-promise-icon.svg',
    iconBackgroundColor: '#DBE7FF',
  },
  {
    title: 'Verified Reviews',
    description:
      'Planners that book through The Bash can leave a review on the vendor’s profile after their event. The Bash does not remove or edit reviews so planners can feel confident when booking.',
    icon: '/images-next/guarantee-page/verified-reviews-icon.svg',
    iconBackgroundColor: '#E8F0AA',
  },
  {
    title: 'On-Hand Support ',
    description:
      "Our Account Specialists are available by email or phone. They're happy to help find the best vendors for your event, handle any cancellations, and assist with any last minute replacements.",
    icon: '/images-next/guarantee-page/on-hand-support-icon.svg',
    iconBackgroundColor: '#EEE3F7',
  },
];

const BookingBenefits = () => (
  <SectionContainer sx={{ textAlign: 'center', backgroundImage: `url(${background})` }}>
    <Typography
      variant="h2"
      sx={(theme) => ({ backgroundColor: theme.palette.background.default })}
    >
      Our Booking Benefits Have You Covered
    </Typography>
    <Typography
      variant="body1"
      sx={(theme) => ({
        maxWidth: 828,
        margin: '0 auto 32px',
        backgroundColor: theme.palette.background.default,
      })}
    >
      {`A little peace of mind goes a long way, especially when it comes to celebrating life's biggest
      moments. That's why The Bash includes key benefits every time you book with us.`}
    </Typography>
    <Box display="flex" gap={4} flexWrap="wrap" pb={8}>
      {BOOKING_BENEFIT_ITEMS.map((item) => (
        <BookingBenefitCard key={item.title} {...item} />
      ))}
    </Box>
  </SectionContainer>
);

export default BookingBenefits;
